import { getMemberReferralEnabledAndMemberGroupAutomation } from '@pm/super-library-2/modules/member';
import { getDailyMissionEnabledAndLuckyWheelDetails as getMissionAndWheelDetails } from '@pm/super-library-2/modules/mission-diary';

import { gu_getNestedValue } from 'root/util/general-util';
import { referralAction, luckyWheelAction, depositProgressBarAction, missionDiaryAction } from 'root/redux/action';

export const consolidateAPIAction = {
    getReferralTypeEnabledAndMemberSummaryGroupAutomation,
    getDailyMissionEnabledAndLuckyWheelDetails,
};

function getReferralTypeEnabledAndMemberSummaryGroupAutomation(vm) {
    return (dispatch) => {
        return new Promise(function (resolve, reject) {
            try {
                getMemberReferralEnabledAndMemberGroupAutomation()
                    .then((data) => {
                        const { memberGroupAutomationSummaryDTO, referralTypeResonseDTO, disableMemberBecomeReferral, multiTierRefCommSettingDTO } = data;

                        let setReferralTypeEnabled = {
                            disableMemberBecomeReferral: disableMemberBecomeReferral || false,
                            referralTypeResonseDTO: referralTypeResonseDTO || {},
                        };

                        if (referralTypeResonseDTO) {
                            dispatch(referralAction.getReferralTypeEnabled(setReferralTypeEnabled));
                        }

                        if (memberGroupAutomationSummaryDTO) {
                            dispatch(depositProgressBarAction.getDepositProgressBarDetails(memberGroupAutomationSummaryDTO));
                        }

                        if (multiTierRefCommSettingDTO) {
                            if (typeof multiTierRefCommSettingDTO === 'object' && multiTierRefCommSettingDTO?.enabled) {
                                const version = multiTierRefCommSettingDTO?.type?.toLowerCase() === 'v2' ? 'v2' : undefined;
                                multiTierReferralMapping(multiTierRefCommSettingDTO, dispatch, vm, resolve, version);
                            }
                        }

                        resolve(data);
                    })
                    .catch(() => {
                        reject(false);
                    });
            } catch (e) {
                return false;
            }
        });
    };
}

function multiTierReferralMapping(data, dispatch, vm, resolve, version) {
    let multiTierReferral = {
        isMultiTierReferral: data?.enabled,
        showWinLoss: gu_getNestedValue(vm.props, 'portal.settings.features.multiTierReferral.showWinLoss'),
        showTurnOver: gu_getNestedValue(vm.props, 'portal.settings.features.multiTierReferral.showTurnOver'),
        multiTierReferralVersion: version ? version : 'v1',
    };

    dispatch(referralAction?.getReferralMultiTier(multiTierReferral));
    resolve(multiTierReferral?.isMultiTierReferral);
}

function getDailyMissionEnabledAndLuckyWheelDetails(cached = true) {
    return (dispatch) => {
        return new Promise(function (resolve, reject) {
            try {
                getMissionAndWheelDetails(cached)
                    .then((response) => {
                        const { luckyWheelDetail, isDailyMissionEnabled, isDailyCheckInEnabled, isManualSequenceEnabled } = response?.data || {};

                        dispatch(luckyWheelAction.getLuckyWheelDetails(luckyWheelDetail));
                        dispatch(missionDiaryAction.isMissionDiaryEnabled(isDailyMissionEnabled));
                        dispatch(missionDiaryAction.isMissionDiaryCheckInEnabled(isDailyCheckInEnabled));
                        dispatch(missionDiaryAction.isManualSequenceEnabled(isManualSequenceEnabled));

                        resolve(response?.data || {});
                    })
                    .catch(() => {
                        reject(false);
                    });
            } catch (e) {
                return false;
            }
        });
    };
}
